module.exports = __webpack_public_path__ + "img/magnify-wolf.bcd343ed.png";